import { i18n } from '../../../i18n'
import exporterRenders from '../../../modules/shared/exporter/exporterRenders'

export default [
  {
    name: 'id',
    label: i18n('entities.subcategory.fields.id'),
  },
  {
    name: 'fintonicId',
    label: i18n('entities.subcategory.fields.fintonicId'),
  },
  {
    name: 'name',
    label: i18n('entities.subcategory.fields.name'),
  },
  {
    name: 'shortname',
    label: i18n('entities.subcategory.fields.shortname'),
  },
  {
    name: 'categoryId',
    label: i18n('entities.subcategory.fields.categoryId'),
  },
  {
    name: 'logo',
    label: i18n('entities.subcategory.fields.logo'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.subcategory.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.subcategory.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
]
